window.addEventListener('load', () => {
  const menuBlocks = document.querySelectorAll('.footer__block--menu');
  if (menuBlocks.length > 0) {
    const wrapper = document.createElement('div');
    wrapper.className = 'footer-menu-inner';
    const parent = menuBlocks[0].parentNode;
    parent.insertBefore(wrapper, menuBlocks[0]);
    menuBlocks.forEach(block => wrapper.appendChild(block));
  }
});

var swiper = new Swiper(".mega-menu__product-slider", {
  slidesPerView: 2,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1149: {
      slidesPerView: 4,
    },
    767: {
      slidesPerView: 3,
      spaceBetween: 18,
    },
    575: {
      slidesPerView: 2,
    },
  },
});

var swiper = new Swiper(".mobile-menu-product-slider", {
  slidesPerView: 2,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1149: {
      slidesPerView: 4,
    },
    767: {
      slidesPerView: 3,
    },
    575: {
      slidesPerView: 2,
    },
  },
});

var swiper = new Swiper(".collection-list-slider", {
  slidesPerView: 1,
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1149: {
      slidesPerView: 3,
      spaceBetween: 27,
    },
    700: {
      slidesPerView: 2,
    },
    575: {
      slidesPerView: 1,
    },
  },
});

function checkAnnouncementBar() {
  const announcementBar = document.querySelector(".announcement-bar");
  if (!announcementBar) return; // exit if not found

  const rect = announcementBar.getBoundingClientRect();
  const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;

  if (isInViewport) {
    document.body.classList.remove("announcement-hidden");
  } else {
    document.body.classList.add("announcement-hidden");
  }
}

document.addEventListener("DOMContentLoaded", checkAnnouncementBar);

document.addEventListener("scroll", checkAnnouncementBar);


// collection tab scroll js starts

document.querySelectorAll('.collection-tabs__nav .collection-tab').forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault();

    const targetId = this.getAttribute('href'); 

    if (!targetId || targetId === "#") return;

    const targetEl = document.querySelector(targetId);
    if (targetEl) {
      const section = targetEl.closest('section');
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });

        history.pushState(null, "", targetId);
      }
    }

    // remove active classes
    document.querySelectorAll('.collection-tabs__nav.active-main-nav').forEach(el => {
      el.classList.remove('active-main-nav');
      el.querySelectorAll('.collection-tab.active').forEach(a => a.classList.remove('active'));
    });

    // add active to clicked one
    this.classList.add('active');
    this.closest('.collection-tabs__nav').classList.add('active-main-nav');
  });
});

  const firstTab = document.querySelector('.collection-tabs__nav .collection-tab');
  if (firstTab) {
    firstTab.classList.add('active');
    firstTab.closest('.collection-tabs__nav').classList.add('active-main-nav');
  }
  
function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom > 0; // partially visible
}

function toggleTabsPosition() {
  const featuredSections = document.querySelectorAll('.shopify-section.shopify-section--featured-collection');
  const tabsSection = document.querySelector('.shopify-section--collection-tabs');

  if (!tabsSection) return;

  let inView = false;

  featuredSections.forEach(section => {
    if (isElementInViewport(section)) {
      inView = true;
    }
  });

  if (inView) {
    tabsSection.style.position = 'sticky';
    tabsSection.style.top = '80'; // optional: keep it at top
    tabsSection.style.width = '100%'; // optional: avoid layout shift
    tabsSection.style.zIndex = '9'; // optional: stay above
    tabsSection.classList.add("fixed-tab-container");
  } else {
    tabsSection.style.position = 'static';
    tabsSection.style.top = '';
    tabsSection.style.width = '';
    tabsSection.style.zIndex = '';
    tabsSection.classList.remove("fixed-tab-container");
  }
}

window.addEventListener('scroll', toggleTabsPosition);
window.addEventListener('load', toggleTabsPosition);

// function setActiveTab(id) {
//   document.querySelectorAll('.collection-tabs__nav.active-main-nav').forEach(el => {
//     el.classList.remove('active-main-nav');
//     el.querySelectorAll('.collection-tab.active').forEach(a => a.classList.remove('active'));
//   });

//   const link = document.querySelector(`.collection-tab[href="#${id}"]`);
//   if (link) {
//     link.classList.add('active');
//     const parent = link.closest('.collection-tabs__nav');
//     if (parent) parent.classList.add('active-main-nav');
//   }
// }

// function onScrollSpy() {
//   const sections = document.querySelectorAll('.floating-controls-container[id]');
//   let currentId = null;

//   sections.forEach(sec => {
//     const rect = sec.getBoundingClientRect();
//     if (rect.top <= window.innerHeight * 0.3 && rect.bottom >= window.innerHeight * 0.3) {
//       currentId = sec.id;
//     }
//   });

//   if (currentId) setActiveTab(currentId);
// }

// window.addEventListener('scroll', onScrollSpy);
// window.addEventListener('load', onScrollSpy); 

// collection tab scroll js ends


// PDP qty starts

var isALARendered;
function ALAcheck() {
  isALARendered = setInterval(function () {
    customALA()
  }, 100);
}
ALAcheck();
function customALA() {
  document.querySelectorAll('.custom-dropdown-select').forEach(dropdown => {
    dropdown.addEventListener('change', function () {

      const input = this.parentElement.querySelector(".quantity-selector__input")
      input.value = this.value;
      // console.log(this.value,"value");

    });
  });

const dropbutton = document.querySelector(".custom-tab-table-select-title");
const optiondropdown = document.querySelector(".custom-tab-table-options");

if (dropbutton && optiondropdown) {
  // Toggle dropdown on title click
  dropbutton.addEventListener("click", function (e) {
    e.preventDefault();
    optiondropdown.classList.toggle("hidden");
  });

  // Handle option click
  document.querySelectorAll("li.custom-tab-table-value").forEach(li => {
    li.addEventListener("click", function () {
      const targetId = this.getAttribute("value");

      // Update dropdown title text
      dropbutton.textContent = this.textContent;

      // Close dropdown
      optiondropdown.classList.add("hidden");

      // Hide all tables
      document.querySelectorAll("table").forEach(table => {
        table.classList.add("hidden");
      });

      // Show matched table
      const targetTable = document.getElementById(targetId);
      if (targetTable) {
        targetTable.classList.remove("hidden");
      }

      // Active state for li
      document.querySelectorAll("li.custom-tab-table-value").forEach(el => {
        el.classList.remove("active");
      });
      this.classList.add("active");
    });
  });

  // Close dropdown when clicking outside
  document.addEventListener("click", function (e) {
    if (!dropbutton.contains(e.target) && !optiondropdown.contains(e.target)) {
      optiondropdown.classList.add("hidden");
    }
  });
}


  // const selectOptions = document.querySelector(".custom-tab-table-options");

  // if (selectOptions) {
  //   selectOptions.addEventListener("change", function () {
  //     const selectedId = this.value;
  //     const allTables = document.querySelectorAll("table");

  //     allTables.forEach(table => {
  //       if (table.id === selectedId) {
  //         table.classList.remove("hidden");
  //       } else {
  //         table.classList.add("hidden");
  //       }
  //     });
  //   });
  // }


  
}

// PDP qty ends

document.addEventListener("DOMContentLoaded", function () {
    const bundlePack = document.querySelector("#bundle-pack");
    const footer = document.querySelector("footer");

    if (!bundlePack || !footer) return;

    function checkFooter() {
        const footerRect = footer.getBoundingClientRect();
        if (footerRect.top < window.innerHeight) {
            bundlePack.classList.remove("show-pack-bar");
        } else {
            bundlePack.classList.add("show-pack-bar");
        }
    }

    checkFooter();

    window.addEventListener("scroll", checkFooter);
});

function initBundleToggle() {
  if ($(window).width() <= 999) {
    $('.bundle-pack__header').off('click.bundleToggle').on('click.bundleToggle', function() {
      const $slots = $(this).next('.bundle-pack__slots');
      $slots.slideToggle(300).toggleClass('active');
    });
  } else {
    $('.bundle-pack__slots').removeClass('active');
    $('.bundle-pack__header').off('click.bundleToggle');
  }
}
$(document).ready(initBundleToggle);
$(window).on('resize', initBundleToggle);


var swiper = new Swiper(".icon-text-swiper", {
  slidesPerView: 1,
  spaceBetween: 20,
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  }
});

// FAQs tab js starts
document.querySelectorAll('a.custom-tab').forEach(anchor => {
  anchor.addEventListener("click", function (e) {
    const targetId = this.getAttribute("href").substring(1); // remove #
    const targetEl = document.getElementById(targetId);

    if (targetEl) {
      e.preventDefault();

      const sectionEl = targetEl.closest("section");

      if (sectionEl) {
        sectionEl.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }

      document.querySelectorAll('a.custom-tab').forEach(tab => {
        tab.classList.remove("active");
      });

      this.classList.add("active");

    }
  });
});

const faqSections = document.querySelectorAll(".shopify-section.shopify-section--faq");
const tabsSection = document.querySelector(".shopify-section.shopify-section--custom-tabs");

function isElementInViewports(el) {
  const rect = el.getBoundingClientRect();
  return rect.bottom > 0 && rect.top < window.innerHeight;
}

function updateSticky() {
  if (!tabsSection) return;

  const stickyTab = tabsSection.querySelector(".sticky-tab");
  if (!stickyTab) {
    tabsSection.classList.remove("is-sticky");
    return;
  }

  const anyVisible = Array.from(faqSections).some(section => isElementInViewports(section));

  if (anyVisible) {
    tabsSection.classList.add("is-sticky");
  } else {
    tabsSection.classList.remove("is-sticky");
  }
}

window.addEventListener("scroll", updateSticky);
// window.addEventListener("resize", updateSticky);
window.addEventListener("load", updateSticky);

updateSticky();

// FAQs tab js ends


var isALARendereds;
function ALAchecks() {
  isALARendereds = setInterval(function () {
    customALAs()
  }, 100);
}
ALAchecks();
function customALAs() {
  const varinatPortions = document.querySelectorAll(".custom-portion-swatch");
  const portionBox = document.getElementById("wc_product_portion");

  if(varinatPortions){
    varinatPortions.forEach(variantOpt => {
      
      variantOpt.addEventListener("click", function () {
        const portionValue = this.getAttribute("data-portion-value");
        // console.log(portionValue,"value");
        portionBox.innerText = portionValue;
      });
    });
  }
}